module.exports = __webpack_public_path__ + "static/pyry5-7314d8f5f00d0fc47723b2f85086b7c6.jpg";